module.exports = __webpack_public_path__ + "assets/asset_mining.1164199e.svg";